import { render, staticRenderFns } from "./player-interface.vue?vue&type=template&id=753f4996&"
import script from "./player-interface.vue?vue&type=script&lang=js&"
export * from "./player-interface.vue?vue&type=script&lang=js&"
import style0 from "./player-interface.vue?vue&type=style&index=0&id=753f4996&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports